import * as api from '../api/connect';
import q from '../query';
export const connectConnectionsFromKey = `connect-connections-from`;
export const useConnectConnectionsFrom = () => q.query(connectConnectionsFromKey, api.connectionsFrom, []);
export const connectConnectionsKey = `connect-connections`;
export const useConnectConnections = () => q.query(connectConnectionsKey, api.connections, []);
export const connectMappingEntityMappingsKey = (caseId) => `cases-${caseId}-connect-entity-mappings`;
export const useConnectMappingEntityMappings = (caseId, options = {}) => {
    var _a;
    return q.query(connectMappingEntityMappingsKey(caseId), () => api.getEntityMappings(caseId).then((res) => {
        const lookup = {};
        for (const mapping of res) {
            const fromThisTenant = mapping.originCaseId === caseId;
            for (const entityMapping of mapping.entityMappings) {
                if ((fromThisTenant && entityMapping.source === 'CREATED') ||
                    (!fromThisTenant && entityMapping.source === 'ORIGIN')) {
                    const id = fromThisTenant
                        ? entityMapping.createdEntityId
                        : entityMapping.originEntityId;
                    lookup[id] = {
                        connectionId: entityMapping.connectConnectionId,
                    };
                }
            }
        }
        return lookup;
    }), [], {
        enabled: ((_a = options.enabled) !== null && _a !== void 0 ? _a : true) ? caseId != null : false,
    });
};
export const connectCaseMappingOnCaseKey = (caseId) => `connect-case-mappings-on-case-${caseId}`;
export const useConnectCaseMappingOnCase = (caseId, options = {}) => {
    var _a;
    return q.query(connectCaseMappingOnCaseKey(caseId), () => api.getCaseMappingsOnCase(caseId), [], {
        enabled: ((_a = options.enabled) !== null && _a !== void 0 ? _a : true) ? caseId != null : false,
    });
};
export const connectConnectionKey = (id) => `connect-connections-${id}`;
export const useConnectConnection = (id) => q.query(connectConnectionKey(id), () => api.connectionsById(id), [], {
    enabled: !!id,
});
export const connectProoductKey = (id) => `connect-products-${id}`;
export const useConnectProduct = (id) => q.query(connectProoductKey(id), () => api.productsById(id), [], {
    enabled: !!id,
});
export const connectCaseMappingKey = (id) => `connect-case-mappings-${id}`;
export const useConnectCaseMapping = (id) => q.query(connectCaseMappingKey(id), () => api.getCaseMapping(id), []);
export const connectCaseMappingsOnConnectionKey = (connectionId) => `connect-case-mappings-on-connection-${connectionId}`;
export const useConnectCaseMappingOnConnection = (connectionId) => q.query(connectCaseMappingsOnConnectionKey(connectionId), () => api.getCaseMappingsOnConnection(connectionId), []);
//# sourceMappingURL=index.js.map